module.exports = __webpack_public_path__ + "action_plan-1ecafac3404b4ffe31b9d4fc7c789b0c.png";